import type { UserToken } from '~/types/UserData'
// Subpath, not the barrel: the barrel pulls in zod (#1982).
import { isEntraUser } from 'microsoft-auth/provider'

export const useAuthStore = defineStore('AuthStore', {
  state: () => ({
    token: {} as UserToken | undefined,
  }),
  actions: {
    async setToken() {
      const headers = useRequestHeaders(['cookie']) as HeadersInit
      const token = await $fetch('/api/token', { headers })
      if (isValidUserToken(token)) {
        this.token = token
      }
    },
  },
  getters: {
    getTokenId: state => {
      if (state.token !== undefined) {
        return state.token.sub
      }
    },
  },
})

// Type guard for the token
function isValidUserToken(token: any): token is UserToken {
  return (
    token &&
    typeof token === 'object' &&
    'name' in token &&
    'sub' in token &&
    ('bankidUserId' in token ||
      ('email' in token && 'picture' in token) ||
      (isEntraUser(token) && 'email' in token))
  )
}
